import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://tvegymtaledpgriztgfu.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'anon-key-placeholder';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export const APP_ENV = import.meta.env.VITE_APP_ENV || 'development';
